<ng-content select="app-activity-title"></ng-content>

<div [@bodyExpansion]="expandedState">
  <ng-content select="app-activity-content"></ng-content>

  <ng-content select="app-activity-stepper"></ng-content>

  <ng-content select="app-activity-actions"></ng-content>
</div>
